/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_CreateInputs */

const en_cargo_create = /** @type {(inputs: Cargo_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Cargo`)
};

const es_cargo_create = /** @type {(inputs: Cargo_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear carga`)
};

/**
* | output |
* | --- |
* | "Create Cargo" |
*
* @param {Cargo_CreateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_create = /** @type {((inputs?: Cargo_CreateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_CreateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_create(inputs)
	return es_cargo_create(inputs)
});